// src/services/supplierService.js
import { authenticatedFetch, handleApiError } from './api';

const API_URL = '/suppliers';

const getAllSuppliers = () => {
  return authenticatedFetch(API_URL).catch(handleApiError);
};

const createSupplier = (supplierData) => {
  return authenticatedFetch(API_URL, {
    method: 'POST',
    body: JSON.stringify(supplierData),
  }).catch(handleApiError);
};

const updateSupplier = (id, supplierData) => {
  return authenticatedFetch(`${API_URL}/${id}`, {
    method: 'PUT',
    body: JSON.stringify(supplierData),
  }).catch(handleApiError);
};

const deleteSupplier = (id) => {
  return authenticatedFetch(`${API_URL}/${id}`, {
    method: 'DELETE',
  }).catch(handleApiError);
};

const supplierService = {
  getAllSuppliers,
  createSupplier,
  updateSupplier,
  deleteSupplier,
};

export default supplierService;
